module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"followHere":"Folge {artist} hier!"},"en":{"followHere":"Follow {artist} here!"}}')
  delete Component.options._Ctor
}
